import { render, staticRenderFns } from "./OverviewModal.vue?vue&type=template&id=2deac99c&scoped=true&"
import script from "./OverviewModal.vue?vue&type=script&lang=js&"
export * from "./OverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./OverviewModal.vue?vue&type=style&index=0&id=2deac99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deac99c",
  null
  
)

export default component.exports